import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {state} from "./state"
import {getters} from "./getters"
import {mutations} from "./mutations"
import {actions} from "./actions"
import {queries} from './queries/store';

Vue.use(Vuex);

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        queries
    },
    plugins: [createPersistedState()],
    strict: process.env.NODE_ENV !== 'production'
})
